import { render, staticRenderFns } from "./PhoneList.vue?vue&type=template&id=0913a8b0&scoped=true"
import script from "./PhoneList.vue?vue&type=script&lang=js"
export * from "./PhoneList.vue?vue&type=script&lang=js"
import style0 from "./PhoneList.vue?vue&type=style&index=0&id=0913a8b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0913a8b0",
  null
  
)

export default component.exports